export const RP_ACTUAL_SUPPLY_MODEL_LIST = 'RP_ACTUAL_SUPPLY_MODEL_LIST'
export const RP_ACTUAL_SUPPLY_SEARCH = 'RP_ACTUAL_SUPPLY_SEARCH'
export const RP_ACTUAL_SUPPLY_PAGINATION = 'RP_ACTUAL_SUPPLY_PAGINATION'
export const RP_ACTUAL_SUPPLY_DROP_DOWN_SEARCH_YEAR = 'RP_ACTUAL_SUPPLY_DROP_DOWN_SEARCH_YEAR'
